module.exports = __webpack_public_path__ + "media/images/flags/4x3/isl-89be1b7112f0cd01b865bb7a27171d9e.svg";